<template>
    <div class="article-wrapper">
        <h4>{{chapter.name}}</h4>
        <audio style="width:100%;" ref="yushuAudio" :src="url" controls="controls" @play="onAudioStart" @pause="onAudioPause" @ended="onAudioEnd" @canplay="onAudioReady">
            Your browser does not support the audio element.
        </audio>

        <div class="content" v-html="chapter.textMaterial"></div>
    </div>
</template>
<script>
import ResourceAPI from "@/web-framework/api/resources.js";
export default {
    name: 'YushuAudio',
    props: {
        forceLook: {                    // 是否强制观看
            type: Boolean,
            default: true
        },
        writeProgress: {                // 是否记录进度
            type: Boolean,
            default: true
        },
        intervalToWriteProgress: {      // 记录进度时间间隔
            type: Number,
            default: 20
        }
    },
    data() {
        return {
            url: '',                // 当前播放的网址
            duration: 0,            // 音频总市场
            handler: '',            // 播放句柄
            player: '',             // 播放器
            chapter: {},            // 当前章节
            resource: {},           // 播放资源
        };
    },
    methods: {
        // 执行初始化
        init(chapter, resource) {
            this.player = this.$refs.yushuAudio;
            this.$nextTick(() => {
                this.chapter = chapter;
                if (!resource) {
                    this.loadResource(chapter);
                } else {
                    this.resource = resource;
                    this.url = this.Utils.getResourceUrl(this.resource.url);
                }
            });
            return this.player;
        },
        // 音频已准备好开始播放
        onAudioReady() {
            this.duration = parseInt(this.$refs.yushuAudio.duration);
        },
        // 音频播放
        onAudioStart() {
            if (this.handler) {
                window.clearInterval(this.handler);
                this.handler = null;
            }

            if (!this.writeProgress)
                return;

            this.$emit('onPlayStart', 0, 0);

            this.handler = window.setInterval(() => {
                this.onAudioProgress();
            }, this.intervalToWriteProgress * 1000);
        },
        // 音频暂停
        onAudioPause() {
            if (this.handler) {
                window.clearInterval(this.handler);
                this.handler = null;
            }

            if (!this.writeProgress)
                return;
            try {
                let currentTime = parseInt(this.$refs.yushuAudio.currentTime);
                let percent = currentTime / this.duration * 100;
                this.$emit('onPlayPause', currentTime, percent)
            } catch (exception) {
            }
        },
        // 音频播放完毕
        onAudioEnd() {
            if (this.handler) {
                window.clearInterval(this.handler);
                this.handler = null;
            }

            if (!this.writeProgress)
                return;

            this.$emit('onPlayFinished', parseInt(this.duration), 100)
        },
        // 音频播放中，跟踪播放进度
        onAudioProgress() {
            if (!this.writeProgress)
                return;
            try {
                let currentTime = parseInt(this.$refs.yushuAudio.currentTime);
                let percent = currentTime / this.duration * 100;
                this.$emit('onPlayProgress', currentTime, percent)
            } catch (exception) {
            }
        },
        // 加载资源
        loadResource(chapter) {
            ResourceAPI.getResourceInfoByUnique(chapter.fileId).then(result => {
                Request.validateResult(result, () => {
                    this.resource = result.data;
                    this.url = this.Utils.getResourceUrl(this.resource.url);
                });
            });
        },
        // 销毁
        destory() {
            this.onAudioEnd();
            Vue.set(this, 'player', '');
            Vue.set(this, 'url', '');
            Vue.set(this, 'chapter', '');
            Vue.set(this, 'resource', '');
        }
    },
    mounted() {
    }
};
</script>
<style lang="less" scoped>
.article-wrapper {
    padding: 30px;
    .content {
        font-size: 15px;
        line-height: 28px;
        text-indent: 2em;
        color: #424242;
    }
    h4 {
        text-align: center;
        font-size: 16px;
        height: 50px;
        font-size: 18px;
        color: #4f4f4f;
    }
    .finish-button {
        position: fixed;
        right: 50px;
        top: 40%;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #13ce66;
        border-color: #13ce66;
        color: #ffffff;
        margin: 0 auto;
        text-align: center;
        padding-top: 20px;
        cursor: pointer;
        &:hover {
            background-color: #00d961;
        }
        i {
            font-size: 16px;
        }
        .finish-text {
            font-size: 16px;
            font-weight: bold;
        }
    }
}
</style>